const mapData = [
  { name: "北京", value: 177 },
  { name: "天津", value: 42 },
  { name: "河北", value: 102 },
  { name: "山西", value: 81 },
  { name: "内蒙古", value: 47 },
  { name: "辽宁", value: 67 },
  { name: "吉林", value: 82 },
  { name: "黑龙江", value: 66 },
  { name: "上海", value: 24 },
  { name: "江苏", value: 92 },
  { name: "浙江", value: 114 },
  { name: "安徽", value: 109 },
  { name: "福建", value: 116 },
  { name: "江西", value: 91 },
  { name: "山东", value: 119 },
  { name: "河南", value: 137 },
  { name: "湖北", value: 116 },
  { name: "湖南", value: 114 },
  { name: "重庆", value: 91 },
  { name: "四川", value: 125 },
  { name: "贵州", value: 62 },
  { name: "云南", value: 83 },
  { name: "西藏", value: 9 },
  { name: "陕西", value: 80 },
  { name: "甘肃", value: 56 },
  { name: "青海", value: 10 },
  { name: "宁夏", value: 18 },
  { name: "新疆", value: 67 },
  { name: "广东", value: 123 },
  { name: "广西", value: 59 },
  { name: "海南", value: 14 }
]

const option = {
  title: {
    text: '全国物流热力图',
    left: 10,
    top: 20,
    textStyle: {
      color: '#2ec5d0'
    }
  },
  tooltip: {
    show: true
  },
  visualMap: {
    type: 'continuous',
    max: 50,
    calculable: false,
    inRange: {
      color: ['#9EE1FE', '#2654A3']
    },
    textStyle: {
      color: '#fff'
    }
  },
  series: [
    {
      type: 'map',
      map: 'china',
      zoom: 1.1,
      label: {
        emphasis: {
          show: false
        }
      },
      itemStyle: {
        normal: {
          borderColor: '#fff',
          borderWidth: 1
        }
      },
      emphasis: {
        itemStyle: {
          areaColor: 'rgb(128, 128, 128)',
          opacity: 0.5
        }
      },
      tooltip: {
        backgroundColor: "#FFF",
        borderColor: "#FFF",
        textStyle: {
          color: '#0052FF',
          fontSize: 15
        },
        formatter: function (params) {
          if (params.value) {
            return '&nbsp;&nbsp;' + params.name + '&nbsp;&nbsp;&nbsp;' + params.value + '万吨&nbsp;&nbsp;';
          } else {
            return '&nbsp;&nbsp;' + params.name + '&nbsp;&nbsp;&nbsp;0万吨&nbsp;&nbsp;';
          }
        }
      },
      data: mapData
    }
  ]
}

export default {
  mapData,
  option
}
